import { AuthErrorMessage } from '@stormotion-auth/core/dist/generated/graphql';

export default {
  cardDeclined: 'Your card was declined',
  cityIsRequired: 'City is a required field',
  countryIsRequired: 'Country is a required field',
  differentPasswords: 'Your passwords should be different',
  digitsAndLetters: 'Must be digits and uppercase letters',
  driverNotSelected: 'Please select user from the list',
  mustBeOnlySymbols: 'Must be only symbols',
  passwordsShouldMatch: 'Your passwords should match',
  projectExists: 'Project with this name already exists',
  stateIsRequired: 'State is a required field',
  streetIsRequired: 'Street address is a required field',
  wrongPassword: 'Your password should be at least 6 characters long',
  zipIsRequired: 'Zip code is a required field',
  [AuthErrorMessage.UsernameAlreadyExist]:
    'This email is already linked to a Completely account. Please sign in.',
  [AuthErrorMessage.EmailAssociatedWithAnotherProvider]:
    'This email is already linked to a Completely account using Google/Slack. Please sign in using it',
};
